/**
 * @generated SignedSource<<c80d3e1f27a1cb65b8d8a8030ce44969>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomEditTabs_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditMain_data">;
  readonly " $fragmentType": "RoomEditTabs_data";
};
export type RoomEditTabs_data$key = {
  readonly " $data"?: RoomEditTabs_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomEditTabs_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomEditTabs_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomEditMain_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "00e7ff6f2a9dd8f8382979a19dd395e2";

export default node;
